import { Injectable, signal } from '@angular/core';
import { Budget, QueryMode, TagsMatch } from './hindsight.models';

export interface HindsightSettings {
  apiBaseUrl: string;
  mode: QueryMode;
  budget: Budget;
  maxTokens: number;
  tags: string;
  tagsMatch: TagsMatch;
}
export const HINDSIGHT_DEFAULTS: HindsightSettings = {
  apiBaseUrl: '', mode: 'recall', budget: 'low', maxTokens: 2048, tags: '', tagsMatch: 'all_strict',
};
const STORAGE_KEY = 'jk.hindsight.settings.v1';
@Injectable({ providedIn: 'root' })
export class HindsightSettingsService {
  private readonly state = signal<HindsightSettings>(this.load());
  readonly value = this.state.asReadonly();

  save(settings: HindsightSettings): void {
    const value = { ...settings, apiBaseUrl: settings.apiBaseUrl.trim().replace(/\/+$/, '') };
    if (!this.valid(value)) throw new Error('設定格式不正確，請確認 API 網址與 max_tokens 正整數。');
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    this.state.set(value);
  }
  private valid(value: HindsightSettings): boolean {
    return typeof value.apiBaseUrl === 'string'
      && (!value.apiBaseUrl || /^https?:\/\//i.test(value.apiBaseUrl) || value.apiBaseUrl.startsWith('/'))
      && ['recall', 'reflect'].includes(value.mode) && ['low', 'mid', 'high'].includes(value.budget)
      && Number.isInteger(value.maxTokens) && value.maxTokens > 0 && typeof value.tags === 'string'
      && ['any', 'all', 'any_strict', 'all_strict', 'exact'].includes(value.tagsMatch);
  }
  private load(): HindsightSettings {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null') as HindsightSettings | null;
      if (value && this.valid(value)) return value;
    } catch { /* 無法讀取或舊設定損壞時使用預設值。 */ }
    return { ...HINDSIGHT_DEFAULTS };
  }
}
